import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCheckbox',
  setup(__props) {

const defaultCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/defaultCheckbox.vue"))
const customCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/customCheckbox.vue"))
const defaultRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/defaultRadio.vue"))
const imagesCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/imagesCheckbox.vue"))
const imagesRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/imagesRadio.vue"))
const custumRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/custumRadio.vue"))
const defaultSwitches = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/defaultSwitches.vue"))
const inlineInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/inlineInput.vue"))
const animatedButtons = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/animatedButtons.vue"))
const checkboxRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/checkboxRadio.vue"))
const radioToggle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/checkboxradio/radioToggle.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      title: "Checkbox & Radio"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(defaultCheckbox)),
        _createVNode(_unref(customCheckbox)),
        _createVNode(_unref(defaultRadio)),
        _createVNode(_unref(imagesCheckbox)),
        _createVNode(_unref(imagesRadio)),
        _createVNode(_unref(custumRadio)),
        _createVNode(_unref(defaultSwitches)),
        _createVNode(_unref(inlineInput)),
        _createVNode(_unref(animatedButtons)),
        _createVNode(_unref(checkboxRadio)),
        _createVNode(_unref(radioToggle))
      ])
    ])
  ], 64))
}
}

})